var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24ZM12 1.71429C17.6571 1.71429 22.2857 6.34286 22.2857 12C22.2857 17.6571 17.6571 22.2857 12 22.2857C6.34286 22.2857 1.71429 17.6571 1.71429 12C1.71429 6.34286 6.34286 1.71429 12 1.71429Z",
    fill: "#066FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2853 11.9999C22.2853 6.3428 17.6567 1.71423 11.9996 1.71423C6.34244 1.71423 1.71387 6.3428 1.71387 11.9999C1.71387 17.6571 6.34244 22.2857 11.9996 22.2857C17.6567 22.2857 22.2853 17.6571 22.2853 11.9999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8573 16.2857H14.5716V18H9.42871V16.2857H11.143V11.1429H9.42871V9.42859H12.8573V16.2857Z",
    fill: "#066FEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 7.71425C12.6853 7.71425 13.2853 7.11425 13.2853 6.42854C13.2853 5.74282 12.6853 5.14282 11.9996 5.14282C11.3139 5.14282 10.7139 5.74282 10.7139 6.42854C10.7139 7.11425 11.3139 7.71425 11.9996 7.71425Z",
    fill: "#066FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconInfo);
export default __webpack_public_path__ + "static/media/notification-icon-info.dbaee9b97a83c3b904f854f65bcaefc0.svg";
export { ForwardRef as ReactComponent };